export default __webpack_public_path__ + "static/media/Group 3213@2x.4803ac81.png";